// src/components/FullCalendar/Holidays.js
// Cálculo automático de feriados nacionais brasileiros para qualquer ano.

/**
 * Calcula a data da Páscoa (Easter) usando o algoritmo de Meeus/Jones/Butcher.
 * Retorna um objeto Date.
 */
function getEaster(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31); // 3 = março, 4 = abril
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
}

/**
 * Formata Date para string ISO "YYYY-MM-DD".
 */
function toISO(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
}

/**
 * Adiciona (ou subtrai) dias a uma Date e retorna nova Date.
 */
function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

/**
 * Gera todos os feriados nacionais brasileiros para um dado ano.
 */
function getHolidaysForYear(year) {
    const easter = getEaster(year);

    // Feriados fixos
    const fixed = [
        { date: `${year}-01-01`, title: "Confraternização Universal" },
        { date: `${year}-04-21`, title: "Tiradentes" },
        { date: `${year}-05-01`, title: "Dia do Trabalho" },
        { date: `${year}-09-07`, title: "Independência do Brasil" },
        { date: `${year}-10-12`, title: "Nossa Senhora Aparecida" },
        { date: `${year}-11-02`, title: "Finados" },
        { date: `${year}-11-15`, title: "Proclamação da República" },
        { date: `${year}-11-20`, title: "Dia da Consciência Negra" },
        { date: `${year}-12-25`, title: "Natal" },
    ];

    // Feriados móveis (baseados na Páscoa)
    const movable = [
        { date: toISO(addDays(easter, -48)), title: "Carnaval" },       // Segunda de Carnaval
        { date: toISO(addDays(easter, -47)), title: "Carnaval" },       // Terça de Carnaval
        { date: toISO(addDays(easter, -2)), title: "Sexta-feira Santa" },
        { date: toISO(addDays(easter, 60)), title: "Corpus Christi" },
    ];

    return [...fixed, ...movable].sort((a, b) => a.date.localeCompare(b.date));
}

/**
 * Gera feriados para um range de anos (padrão: ano atual -1 até +5).
 */
function generateHolidays() {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 1;
    const endYear = currentYear + 5;
    const all = [];
    for (let y = startYear; y <= endYear; y++) {
        all.push(...getHolidaysForYear(y));
    }
    return all;
}

// Gera os feriados uma vez e cria um Map para lookup O(1)
const HOLIDAYS = generateHolidays();
const HOLIDAY_MAP = new Map(HOLIDAYS.map((h) => [h.date, h]));

/**
 * Retorna o feriado para uma data ISO "YYYY-MM-DD", ou undefined.
 */
export const getHolidayByDate = (dateStr) => HOLIDAY_MAP.get(dateStr);
